import { GridItem } from "@/types/card";

export const mock_griditem_red: GridItem = [
  {
    id: "1",
    img: "flamecaller",
    type: "avatar",
  },
  {
    id: "3",
    img: "red_desert",
    type: "site",
  },
];
